import { accountQueryKey } from 'api-validations/user-api'
import { type ApiClient, useApiClient, useMutation, useQueryClient } from 'shared-ui/api-provider'
import type { ApiError } from 'utils'

import { queryKey as operationsQueryKey } from './useOperationUserList'

type Params = {
  username: string
  displayName: string
  email: string
}

const mutationFn = (client: ApiClient) => async (body: Params) => {
  const { status } = await client.put(`/useraccounts/${body.username}`, {
    body
  })

  return status === 204
}

export const useUpdateDisplayName = () => {
  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  return useMutation<boolean, ApiError, Params>({
    mutationFn: mutationFn(apiClient),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [accountQueryKey] })
      queryClient.invalidateQueries({ queryKey: [operationsQueryKey] })
    }
  })
}
